import { Loading } from 'element-ui'

let loading;
let counter = 0;

export function startLoad() {
    if(counter == 0){
        loading = Loading.service({
            background:'rgba(255,255,253,0)'
        });
    }
    counter += 1;
}

export function endLoad() {
    counter -= 1;
    if(counter == 0){
        loading.close();
    }
    
}

